export function getVisualMapOfContinuous(style, dimension = 0, min: number = 0, max: number = 100) {
    const visualMap = {
        type: 'continuous',
        left: 0,
        dimension: dimension,
        orient: 'vertical',
        min: min,
        max: max,
        calculable: true,
        align: 'bottom',
        itemWidth: 15,
        itemHeight: 100,
        showLabel: true,
        precision: 1,
        textStyle: {
            color: '#333333',
            // fontWeight: 600,
            fontSize: style.fontSize - 2
        },
        inRange: {
            SymbolSize: 6,
            color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
        },
        outOfRange: {
            symbolSize: 6,
        },
    }
    return visualMap;
}
export function getVisualMapOfPiecewise(style, dimension: number = 0, pieces: any[] = [], unit: string = '') {
    const visualMap = {
        show: true,
        type: 'piecewise' as 'continuous' | 'piecewise',
        itemSymbol: "circle",
        align: "left",
        left: 0,
        bottom: 0,
        inverse: true,
        pieces: pieces,
        dimension: dimension,
        precision: 1,
        orient: 'vertical',
        itemWidth: style.fontSize - 2,
        itemHeight: 6,
        itemGap: 8,
        showLabel: true,
        formatter: `{value}${unit} - {value2}${unit}`,
        textStyle: {
            color: '#333333',
            // fontWeight: 600,
            fontSize: style.fontSize - 2
        },
        inRange: {
            symbol: 'circle',
            symbolSize: 6,
        },
        outOfRange: {
            symbol: 'circle',
            symbolSize: 6,
            opacity: 0,
        }
    }

    return visualMap;
}
